/* ==========================================================================
Popups
========================================================================== */

'use strict'

//Popovers
function initPopovers() {
  if ($('[data-toggle="popover"]').length) {
    $('[data-toggle="popover"]').ggpopover()
  }
}

//Tooltips
function initTooltips() {
  if ($('[data-toggle="tooltip"]').length) {
    $('[data-toggle="tooltip"]').ggtooltip()
  }
}
